import React from "react";
import { Search, SlidersHorizontal } from "lucide-react";
import {
  LOCATIONS,
  INDUSTRIES,
  EXPERIENCE_LEVELS,
  JOB_TYPES,
} from "@/data/jobs";

const Select = ({ label, value, onChange, options, testid }) => (
  <label className="flex flex-col gap-2">
    <span className="text-xs font-bold uppercase tracking-[0.16em] text-axor-white/50">
      {label}
    </span>
    <div className="relative">
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        data-testid={testid}
        className="w-full cursor-pointer appearance-none rounded-2xl border border-white/[0.1] bg-axor-deep px-4 py-3 text-sm text-axor-white outline-none transition-colors focus:border-axor-cyan"
      >
        {options.map((o) => (
          <option key={o} value={o} className="bg-axor-deep text-axor-white">
            {o}
          </option>
        ))}
      </select>
      <SlidersHorizontal className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-axor-text" />
    </div>
  </label>
);

export const JobFilters = ({ filters, setFilters, search, setSearch }) => (
  <div className="glass-panel rounded-[24px] border border-white/[0.08] p-6">
    <label className="relative block">
      <Search className="absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-axor-text" />
      <input
        type="text"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Search jobs, skills or roles"
        data-testid="job-search-input"
        className="w-full rounded-2xl border border-white/[0.1] bg-axor-deep py-3.5 pl-12 pr-4 text-sm text-axor-white outline-none transition-colors placeholder:text-axor-text focus:border-axor-cyan"
      />
    </label>

    <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-1">
      <Select
        label="Location"
        value={filters.location}
        onChange={(v) => setFilters((f) => ({ ...f, location: v }))}
        options={LOCATIONS}
        testid="filter-location"
      />
      <Select
        label="Industry"
        value={filters.industry}
        onChange={(v) => setFilters((f) => ({ ...f, industry: v }))}
        options={INDUSTRIES}
        testid="filter-industry"
      />
      <Select
        label="Experience"
        value={filters.experience}
        onChange={(v) => setFilters((f) => ({ ...f, experience: v }))}
        options={EXPERIENCE_LEVELS}
        testid="filter-experience"
      />
      <Select
        label="Job Type"
        value={filters.type}
        onChange={(v) => setFilters((f) => ({ ...f, type: v }))}
        options={JOB_TYPES}
        testid="filter-type"
      />
    </div>
  </div>
);
